import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoginTokenGuard } from '@core/guards/login-token.guard';
import { NotLoggedGuard } from '@core/guards/not-logged.guard';
import { environment } from '@environment';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { MustBeAuthorizedGuard } from '@wizbii-components/bo-angular-ui';
import {
  AUTHENTICATION_API_CONFIG,
  AuthenticationWebservice,
  CityWebservice,
  PLACE_API_CONFIG,
} from '@wizbii-utils/angular/webservices';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        canActivate: [NotLoggedGuard, LoginTokenGuard, MustBeAuthorizedGuard],
        loadComponent: () =>
          import('@features/layouts/dashboard-layout/dashboard-layout.component').then(
            (m) => m.DashboardLayoutComponent
          ),
        children: [
          {
            path: FeaturesRoutingEnum.Themes,
            loadChildren: () => import('./themes/themes.module').then((m) => m.ThemeModule),
          },
          {
            path: FeaturesRoutingEnum.Questions,
            loadChildren: () => import('./questions/questions.module').then((m) => m.QuestionsModule),
          },
          {
            path: FeaturesRoutingEnum.Transformers,
            loadChildren: () => import('./transformers/transformers.module').then((m) => m.TransformersModule),
          },
          {
            path: FeaturesRoutingEnum.Suggestions,
            loadChildren: () => import('./suggestions/suggestions.module').then((m) => m.SuggestionsModule),
          },
          {
            path: FeaturesRoutingEnum.Organizations,
            loadChildren: () => import('./organization/organization.module').then((m) => m.OrganizationsModule),
          },
          {
            path: FeaturesRoutingEnum.Product,
            loadChildren: () => import('./products/products.module').then((m) => m.ProductsModule),
          },
          {
            path: FeaturesRoutingEnum.Home,
            loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
          },
          {
            path: FeaturesRoutingEnum.NotFound,
            loadComponent: () =>
              import('@domains/not-found/resource-not-found/resource-not-found.component').then(
                (m) => m.ResourceNotFoundComponent
              ),
          },
        ],
      },
      {
        path: '**',
        loadComponent: () =>
          import('@domains/not-found/not-found/not-found.component').then((m) => m.NotFoundComponent),
      },
    ]),
  ],
  providers: [
    {
      provide: PLACE_API_CONFIG,
      useValue: {
        baseUrl: environment.api.place,
      },
    },
    CityWebservice,

    {
      provide: AUTHENTICATION_API_CONFIG,
      useValue: {
        appId: environment.applicationId,
        baseUrl: environment.api.authentication,
      },
    },
    AuthenticationWebservice,
  ],
})
export class FeaturesModule {}
